// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16gqB","importantInfo":"styles_importantInfo__BgA_D"};